import React, { Component } from 'react';
import styled, { css } from 'styled-components'
import { Button } from '../components/styledComponents';
import { topics } from '../data/topics'
import { questions } from '../data/questions'
 
const TopicHeader = styled.div`
  display: flex;
  width: 100%;
  height: 250px;
  padding: 10px;
  width: calc(100% + 24px);
  margin: -12px;
  margin-bottom: -10px;
  
  > div {
    width: 100%;
    border-bottom: 2px solid rgb(126, 69, 62);
    box-shadow: 0px 1px 3px rgba(0,0,0,0.3);
    background-image: url(${props => props.img});
    background-size: cover;
    background-repeat: no-repeat;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: center;
  }

  > div > span {
    text-align: center;
    width: 100%;
    height: 50px;
    display: block;
    font-size: 35px;
    font-weight: 600;
    text-transform: uppercase;
    margin-top: 10px;
    color: white;
  }
`

const Questions = styled.div`
	width: 100%;
  height: 506px;
	padding: 5px 20px;
	overflow-y: scroll;
`
const QuestionContainer = styled.div`
	width: 100%;
	height: 60px;
	margin-top: 5px;
	display: flex;
	padding: 0;
	user-select: none;
	${props => props.chosen && css`cursor: pointer;`}
	opacity: ${props => props.chosen ? 1 : 0.2};
`
const QuestionText = styled.span`
	display: flex;
  width: 320px;
	font-size: 16px;
	align-items: center;

	${props => props.bold && css`font-weight: bolder;`}
`
const QuestionIcon = styled.div`
	display: block;
  width: 36px;
  height: 36px;
  background-image: url(${props => props.img});
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position: 50% 100%;
`

const AnswerButton = styled(Button)`
	position: absolute;
  width: 50%;
  height: 50px;
  left: 25%;
  bottom: 40px;
  z-index: 2;
`

class Dashboard extends Component {

	decideImage = (i, question) => {
		if (question.locked) {
			return '/icons/private.svg'
		} 
	}

	render() {
		let { topic } = this.props
		if (!topic) {
			topic = 'Confidence'
		}
		const topicData = topics.find(topicData => topicData.title === topic)
		return (
			<div>
				<TopicHeader img={topicData.img}>
				  <div>
			        <span>{topicData.title}</span>
			      </div> 
				</TopicHeader>
				<AnswerButton onClick={this.props.onProceed}>Continue</AnswerButton>
				<Questions>
				{
					questions.map((question, i) => (<QuestionContainer onClick={this.props.onProceed} chosen={i === 0}>
						<QuestionText bold={i === 0}>{question.q}</QuestionText>
						<QuestionIcon img={this.decideImage(i, question)}/>
					</QuestionContainer>))
				}
				</Questions>
			</div>	
		)
	}
}

export default Dashboard;
